import React from "react";
import mainLayer from "../assets/mainL.png";
import layer2 from "../assets/mountains.png";
import { TypeAnimation } from "react-type-animation";

const Main = () => {
  return (
    <div className="relative h-[20vh] md:h-[92vh] overflow-hidden" id="main">
      <div className="w-full text-gray-400 flex flow-row justify-start h-full items-center bottom-[400px] text-3xl md:text-5xl lg:text-7xl">
        <h1 className=" z-30 text-white ml-5 sm:ml-20 mr-2 md:mr-8">
          Pradicksha,
        </h1>
        <TypeAnimation
          sequence={[
            "Backend Software Developer",
            1000,
            "Spring Boot Enthusiast",
            1000,
            "Full Stack Developer",
            1000,
            "React Frontend Developer",
            1000,
            "Database Design & Management",
            1000,
          ]}
          wrapper="span"
          speed={50}
          repeat={Infinity}
        />
        <img
          src={layer2}
          className="z-20 hidden md:block absolute bottom-[0px] w-full object-bottom object-cover"
          alt="layer2"
        />
        <img
          src={mainLayer}
          className="z-10 absolute w-full object-bottom object-cover"
          alt="layer2"
        />
      </div>
    </div>
  );
};

export default Main;
